import React from "react";
import ProfileSectionCard from "./ProfileSectionCard";

const EmailAndPhoneNo = ({ profile }) => {
  const signin_info = [
    {title: 'Email', value: profile.email },
    {title: 'Phone Number', value: '+' + profile.phone_number}
  ];

  return (
    <ProfileSectionCard title="Email & Phone No." showEditButton={false}>
      <p className="text-muted mb-10">The email address and phone number are associated with your BookDoc ID. They can also be used to reach you.</p>
      <div className="profile-info-group">
        {signin_info.map((item, index) => (
          <div className="profile-info-row" key={index}>
            <h6 className="profile-info-label">{item.title}</h6>
            <p className="profile-info-value">{item.value}</p>
          </div>
        ))}
      </div>
    </ProfileSectionCard>
  );
};

export default EmailAndPhoneNo;